<template>
  <div class="exams-skip">
   <div class="exams-skip__header">
      <h2 class="exams-skip__title">Sem problemas, vamos adicionar os exames no guichê:</h2>
      <p class="exams-skip__description">Por favor, nos conte porque não adicionou</p>
    </div>
    <div class="exams-skip__content">
      <ul class="exams-skip__list">
         <li v-for="item in list"
            @click="chooseItem(item)"
            v-bind:key="item.id"
            class="exams-skip__list-item"
         >
            <VInputRadio
               :label="item.title"
               :value="item"
               :id="item.id"
               :name="item.id"
               v-model="selectedItem"
            />
         </li>
      </ul>
      <VInput
         label="Escreva o motivo"
         ref="input"
         id="exams-skip__input"
         type="text"
         class="exams-skip__input"
         v-if="selectedItem.id === 'OTHER'"
         v-model="reason"
      />
   </div>
    <button class="button button--secondary button--secondary--inverse-margin" @click="nextStep" :disabled="!selectedItem">Continuar</button>
  </div>
</template>

<script>
import VInputRadio from '@/components/commons/VInputRadio.vue';
import { dataLayersMixin } from '@/utils/mixins';
import { mapState } from 'vuex';

export default {
  components: {
    VInputRadio
  },
  mixins: [dataLayersMixin],

  data() {
    return {
      list: [
        {
          title: 'Tenho dúvida em qual exame selecionar',
          id: 'DOUBT_EXAM_SELECT'
        },
        {
          title: 'Não quis adicionar os exames',
          id: 'NO_WANT_ADD'
        },
        {
          title: 'Não entendi como fazer',
          id: 'NO_UNDERSTAND'
        },
        {
          title: 'Não encontrei o(s) exame(s)',
          id: 'NOT_FOUND_EXAM'
        },
        {
          title: 'Outro motivo',
          id: 'OTHER'
        },
      ],
      selectedItem: '',
      reason: ''
    };
  },
  computed: {
    ...mapState({ currentAdmission: ({ currentAdmission }) => currentAdmission.data })
  },
  methods: {
    async nextStep() {
      const paymentType = this.currentAdmission.payments && this.currentAdmission.payments.length && this.currentAdmission.payments[0].details.type;
      this.mostCommonPagesAnalytics({
        eventType: 'submit',
        step: 'inserção_pedido_médico_ocr',
        screen: 'justificativa_não_inserção_exame_médico',
        complementaryObject: {
          ...(paymentType === 'PRIVATE' ? {
            payment: {
              type: 'particular'
            }
          } : {
            payment: {

              type: 'convênio'
            }
          }),
          paperless_upload_files: {
            option: 'continuar_sem_adicionar_pedido_médico',
            reason: this.selectedItem.id === 'OTHER' ? `${this.selectedItem.title} - ${this.reason}` : this.selectedItem.title
          },
          previous_choice: this.$route.params.previous_choice
        }
      });

      return this.goNextStep('exams_add');
    },
    chooseItem(item) {
      this.selectedItem = item;
    }
  },
};
</script>

<style lang="scss" scoped>
.exams-skip {
   color: #161616;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   &__title {
      font-weight: 700;
      font-size: 20px;
      line-height: 120%;
      color: #161616;
   }
   &__description {
      padding: 25px 0 18px;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
   }
   &__list {
      margin-bottom: 16px;
   }
   &__list-item {
      margin-bottom: 16px;

      .v-input-radio__label {
         border-width: 0 !important;
      }
   }
   &__input {
      margin: 16px 0;
   }
}
.button {
    font-size: 16px;
    font-weight: var(--font-weight-bold);
    line-height: 24px;
    text-align: center;
    width: 100%;
    padding: 12px 0px;
    border: 1px solid var(--color-button-primary);
    border-radius: 4px;
    background: var(--color-button-primary);
    margin: 0 0 16px 0;
    color: white;
    cursor: pointer;

    &--secondary {
      margin: 0;
      background: white;
      color: var(--color-button-primary);

      & svg {
        vertical-align: middle;
        margin-left: 10px;

        path {
          fill: var(--color-primary);
        }
      }
    }

    &:disabled {
      cursor: not-allowed;
      background-color: var(--color-grey-1);
      border-color: var(--color-grey-5);
      color: var(--color-grey-5);
    }
}
</style>
